module.exports = __webpack_public_path__ + "static/media/how-it-works-poster.15490583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/how-it-works-poster.jpg
// module id = 3555
// module chunks = 0